import React from 'react';

export const PubPageImagePlaceholder = () => {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <mask id="mask0_12777_56392" maskUnits="userSpaceOnUse" x="0" y="0" width="160" height="160">
        <rect width="160" height="160" rx="4" fill="#FFF9D9" />
      </mask>
      <g mask="url(#mask0_12777_56392)">
        <rect width="160" height="160" rx="4" fill="#FFF9D9" />
        <rect y="-1" width="160" height="161" fill="url(#pattern0)" fillOpacity="0.2" />
        <path
          opacity="0.6"
          d="M147.6 36.8859C145.868 36.6671 144.641 35.1185 144.866 33.4369C145.091 31.7552 146.686 30.5632 148.418 30.782C150.15 31.0009 151.378 32.5494 151.152 34.2311C150.927 35.9127 149.332 37.1047 147.6 36.8859Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M134.363 71.0243C132.824 70.8297 131.728 69.4625 131.93 67.9553C132.131 66.4605 133.539 65.3969 135.091 65.5931C136.63 65.7876 137.726 67.1547 137.524 68.662C137.323 70.1568 135.915 71.2204 134.363 71.0243Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M144.83 121.918C143.547 121.756 142.643 120.616 142.81 119.37C142.977 118.124 144.151 117.246 145.434 117.409C146.717 117.571 147.621 118.711 147.454 119.957C147.287 121.202 146.113 122.08 144.83 121.918Z"
          fill="white"
        />
        <path
          opacity="0.2"
          d="M49.533 11.956C48.2501 11.7939 47.3462 10.6536 47.5131 9.40793C47.68 8.16226 48.8544 7.28456 50.1373 7.44665C51.4202 7.60873 52.3241 8.74902 52.1572 9.99469C51.9902 11.2404 50.8159 12.1181 49.533 11.956Z"
          fill="white"
        />
        <path
          opacity="0.5"
          d="M19.496 71.8549C18.7263 71.7576 18.1795 71.0678 18.2796 70.3204C18.3798 69.573 19.0902 69.0421 19.8599 69.1393C20.6296 69.2366 21.1765 69.9264 21.0763 70.6738C20.9762 71.4212 20.2657 71.9521 19.496 71.8549Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M72.9418 65.8636C72.8136 65.8474 72.7243 65.7348 72.741 65.6103C72.7577 65.4857 72.8737 65.399 73.0019 65.4152C73.1302 65.4314 73.2195 65.5441 73.2028 65.6686C73.1861 65.7932 73.0701 65.8799 72.9418 65.8636Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M6.23211 106.218C5.52652 106.129 5.02433 105.495 5.11613 104.81C5.20793 104.125 5.86034 103.638 6.56593 103.727C7.27151 103.816 7.7737 104.449 7.6819 105.134C7.5901 105.819 6.93769 106.307 6.23211 106.218Z"
          fill="white"
        />
        <path
          opacity="0.5"
          d="M49.423 11.3097C48.8457 11.2367 48.4329 10.7159 48.508 10.1554C48.5831 9.59493 49.1195 9.19404 49.6968 9.26698C50.2741 9.33992 50.687 9.86075 50.6119 10.4212C50.5368 10.9817 50.0003 11.3826 49.423 11.3097Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M152.831 40.2965C151.099 40.0777 149.871 38.5292 150.096 36.8475C150.322 35.1658 151.917 33.974 153.649 34.1928C155.38 34.4116 156.608 35.9601 156.383 37.6417C156.157 39.3234 154.562 40.5153 152.831 40.2965Z"
          fill="white"
        />
        <path
          opacity="0.7"
          d="M86.3958 78.607C85.2412 78.4611 84.4265 77.4334 84.5768 76.3123C84.727 75.1912 85.7854 74.4002 86.94 74.5461C88.0946 74.6919 88.9092 75.7196 88.759 76.8407C88.6087 77.9618 87.5504 78.7528 86.3958 78.607Z"
          fill="white"
        />
        <path
          opacity="0.2"
          d="M128.162 108.829C127.649 108.764 127.292 108.313 127.358 107.815C127.425 107.317 127.891 106.958 128.404 107.023C128.917 107.087 129.287 107.54 129.219 108.05C129.152 108.548 128.688 108.895 128.162 108.829Z"
          fill="white"
        />
        <path
          opacity="0.2"
          d="M144.871 83.7549C143.652 83.6009 142.793 82.5169 142.951 81.3335C143.11 80.1501 144.226 79.3158 145.445 79.4697C146.664 79.6237 147.523 80.7077 147.364 81.8911C147.206 83.0744 146.089 83.9088 144.871 83.7549Z"
          fill="white"
        />
        <path
          opacity="0.2"
          d="M104.177 94.2052C102.38 93.9782 101.108 92.3733 101.342 90.6294C101.576 88.8855 103.228 87.6502 105.025 87.8771C106.821 88.104 108.093 89.7089 107.859 91.4528C107.625 93.1967 105.973 94.4321 104.177 94.2052Z"
          fill="white"
        />
        <path
          opacity="0.2"
          d="M114.714 144.536C113.496 144.382 112.636 143.298 112.795 142.114C112.954 140.931 114.07 140.097 115.289 140.251C116.507 140.404 117.367 141.488 117.208 142.672C117.049 143.855 115.933 144.69 114.714 144.536Z"
          fill="white"
        />
        <path
          opacity="0.5"
          d="M144.988 3.51847C144.218 3.42122 143.672 2.73146 143.772 1.98405C143.872 1.23665 144.582 0.705659 145.352 0.802912C146.122 0.900164 146.669 1.59 146.568 2.3374C146.468 3.08481 145.758 3.61572 144.988 3.51847Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter0_f_12777_56392)">
        <rect x="40" y="38" width="79" height="83" fill="#FCB53E" fillOpacity="0.3" />
      </g>
      <g filter="url(#filter1_d_12777_56392)">
        <path
          d="M97.0348 66.9791H95.4463V73.1783H95.9656C97.737 73.1783 99.173 74.566 99.173 76.2779V89.3633C99.173 91.0752 97.737 92.4629 95.9656 92.4629H95.4463V98.6621H97.0348C101.759 98.6621 105.588 94.9614 105.588 90.3965V75.2447C105.588 70.6797 101.759 66.9791 97.0348 66.9791Z"
          fill="#404040"
        />
        <path
          d="M89.2197 57.9199H77.6648H66.1098C64.3383 57.9199 62.9023 59.3077 62.9023 61.0195V63.9826C63.5068 63.7596 64.1465 63.6421 64.8053 63.6421C66.4737 63.6421 68.024 64.3842 69.1706 65.7317L69.1969 65.7624C69.7609 66.4252 70.4829 66.7893 71.2316 66.7893C71.9802 66.7893 72.7023 66.4253 73.2647 65.7643L73.2924 65.7318C74.4392 64.3843 75.9895 63.6421 77.6579 63.6421C79.3263 63.6421 80.8766 64.3842 82.0233 65.7316L82.0512 65.7644C82.6135 66.4252 83.3356 66.7892 84.0843 66.7892C84.8329 66.7892 85.555 66.4252 86.1175 65.7642L86.1451 65.7317C87.2919 64.3842 88.8422 63.642 90.5107 63.642C91.1745 63.642 91.8189 63.7614 92.4274 63.9877V61.0195C92.4272 59.3077 90.9912 57.9199 89.2197 57.9199Z"
          fill="#404040"
        />
        <path
          d="M90.5107 66.5596C89.762 66.5596 89.0399 66.9236 88.4775 67.5846L88.4499 67.6171C87.3031 68.9647 85.7529 69.7068 84.0844 69.7068C82.416 69.7068 80.8656 68.9648 79.719 67.6172L79.6911 67.5845C79.1288 66.9237 78.4067 66.5597 77.6581 66.5597C76.9094 66.5597 76.1873 66.9237 75.6249 67.5847L75.5955 67.6192C74.4504 68.9648 72.9001 69.7069 71.2317 69.7069C69.5633 69.7069 68.0129 68.9649 66.8662 67.6173L66.8383 67.5846C66.276 66.9238 65.5539 66.5598 64.8053 66.5598C64.1132 66.5598 63.4439 66.8715 62.9023 67.4408V107.72H92.4273V67.4548C91.8835 66.8763 91.2088 66.5596 90.5107 66.5596ZM72.7598 100.178H69.7402V75.2476H72.7598V100.178ZM79.1747 100.178H76.1551V75.2476H79.1747V100.178ZM85.5897 100.178H82.5702V75.2476H85.5897V100.178Z"
          fill="#404040"
        />
        <rect x="40.6602" y="45.6401" width="77.68" height="74.36" rx="1" stroke="#404040" strokeWidth="2" />
        <line x1="55.6211" y1="46.0322" x2="55.6211" y2="38" stroke="#404040" strokeWidth="2" />
        <line x1="33" y1="37" x2="127" y2="37" stroke="#404040" strokeWidth="2" />
        <line x1="107.434" y1="46.0322" x2="107.434" y2="38" stroke="#404040" strokeWidth="2" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use
            xlinkHref="#image0_12777_56392"
            transform="translate(-0.4375 -0.000374877) scale(0.000608094 0.000604317)"
          />
        </pattern>
        <filter
          id="filter0_f_12777_56392"
          x="25"
          y="23"
          width="109"
          height="113"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="7.5" result="effect1_foregroundBlur_12777_56392" />
        </filter>
        <filter
          id="filter1_d_12777_56392"
          x="-27"
          y="-20"
          width="214"
          height="205"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="30" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.988235 0 0 0 0 0.709804 0 0 0 0 0.243137 0 0 0 0.9 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12777_56392" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_12777_56392" result="shape" />
        </filter>
        <image id="image0_12777_56392" width="2477" height="1656" />
      </defs>
    </svg>
  );
};
